import BaseNotificationSetting from "@/models/server/notification/BaseNotificationSetting";

export default class GlobalNotificationSetting extends BaseNotificationSetting {
    public id: string = "";

    public pendingDays: number | null = null;

    public isGlobalNotificationSetting: boolean = true;
}